<nz-card class="header-card" nzSize="small">
  <div class="flex justify-start flex-wrap gap-0 xsm:gap-2">
    <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  </div>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xsm:!text-2xl my-0">{{ this.event.name }}</h2>
  </div>
</nz-card>

<nz-card class="!mt-4">
  <div class="flex justify-between items-start gap-8 flex-col md:flex-row">
    <div class="basis-[50%] w-full lg:basis-[45%] xl:basis-[35%]  h-[500px] relative">
      <img class="w-full rounded-lg h-full object-cover" alt="Image" (error)="onImageError($event)"
        [src]="this.event.thumbnail.url" />
    </div>
    <div class="basis-[50%] w-full lg:basis-[55%] xl:basis-[65%]">
      <div class="flex justify-between items-start flex-col 2xl:flex-row pb-[15px]">
        <div>
          <p class="flex justify-start gap-2 items-center !my-0">
            <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.738 12.1832L7.16878 11.6949L7.738 12.1832ZM4.262 12.1832L3.69279 12.6716L4.262 12.1832ZM6 13.5V12.75V13.5ZM10.25 6.41797C10.25 7.01125 9.89933 7.87637 9.27258 8.88918C8.66644 9.8687 7.87869 10.8674 7.16878 11.6949L8.30721 12.6716C9.0409 11.8164 9.88415 10.7514 10.5481 9.6785C11.1915 8.63885 11.75 7.46268 11.75 6.41797H10.25ZM4.83122 11.6949C4.12131 10.8674 3.33356 9.8687 2.72742 8.88918C2.10067 7.87637 1.75 7.01125 1.75 6.41797H0.25C0.25 7.46268 0.808534 8.63885 1.45189 9.6785C2.11585 10.7514 2.9591 11.8164 3.69279 12.6716L4.83122 11.6949ZM1.75 6.41797C1.75 4.12771 3.64105 2.25 6 2.25V0.75C2.83611 0.75 0.25 3.27599 0.25 6.41797H1.75ZM6 2.25C8.35895 2.25 10.25 4.12771 10.25 6.41797H11.75C11.75 3.27599 9.16389 0.75 6 0.75V2.25ZM7.16878 11.6949C6.77522 12.1536 6.53959 12.4244 6.33556 12.5938C6.16603 12.7345 6.08353 12.75 6 12.75V14.25C6.52474 14.25 6.93467 14.046 7.29377 13.7478C7.61838 13.4783 7.94762 13.0907 8.30721 12.6716L7.16878 11.6949ZM3.69279 12.6716C4.05238 13.0907 4.38161 13.4783 4.70623 13.7478C5.06533 14.046 5.47526 14.25 6 14.25V12.75C5.91647 12.75 5.83397 12.7345 5.66444 12.5938C5.46041 12.4244 5.22478 12.1536 4.83122 11.6949L3.69279 12.6716ZM3.375 6.64152C3.375 8.06428 4.61512 9.10536 6 9.10536V7.60536C5.31381 7.60536 4.875 7.11181 4.875 6.64152H3.375ZM6 9.10536C7.38488 9.10536 8.625 8.06428 8.625 6.64152H7.125C7.125 7.11181 6.68619 7.60536 6 7.60536V9.10536ZM8.625 6.64152C8.625 5.21876 7.38488 4.17768 6 4.17768V5.67768C6.68619 5.67768 7.125 6.17122 7.125 6.64152H8.625ZM6 4.17768C4.61512 4.17768 3.375 5.21876 3.375 6.64152H4.875C4.875 6.17122 5.31381 5.67768 6 5.67768V4.17768Z"
                fill="#2D264B" fill-opacity="0.25" />
            </svg>
            <span class="font-semibold">{{ this.event.venue }}</span>
          </p>
          <p class="flex justify-start gap-2 items-center !my-0">
            <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.25955 12.9271L2.69509 12.3165L2.25955 12.9271ZM1.58356 12.2634L2.18644 11.8172L1.58356 12.2634ZM11.4164 12.2634L10.8136 11.8172L11.4164 12.2634ZM10.7405 12.9271L11.176 13.5376L10.7405 12.9271ZM10.7405 3.27295L11.176 2.66237L10.7405 3.27295ZM11.4164 3.93664L10.8136 4.38278L11.4164 3.93664ZM2.25955 3.27295L2.69509 3.88352L2.69509 3.88352L2.25955 3.27295ZM1.58356 3.93664L2.18644 4.38278V4.38278L1.58356 3.93664ZM10.9109 9.93694L10.7957 9.19584L10.9109 9.93694ZM8.37095 12.4307L7.63052 12.3113L8.37095 12.4307ZM4.66667 7.95C4.25245 7.95 3.91667 8.28579 3.91667 8.7C3.91667 9.11421 4.25245 9.45 4.66667 9.45V7.95ZM8.33333 9.45C8.74755 9.45 9.08333 9.11421 9.08333 8.7C9.08333 8.28579 8.74755 7.95 8.33333 7.95V9.45ZM7.58333 3.3C7.58333 3.71421 7.91912 4.05 8.33333 4.05C8.74755 4.05 9.08333 3.71421 9.08333 3.3H7.58333ZM9.08333 1.5C9.08333 1.08579 8.74755 0.75 8.33333 0.75C7.91912 0.75 7.58333 1.08579 7.58333 1.5H9.08333ZM3.91667 3.3C3.91667 3.71421 4.25245 4.05 4.66667 4.05C5.08088 4.05 5.41667 3.71421 5.41667 3.3H3.91667ZM5.41667 1.5C5.41667 1.08579 5.08088 0.75 4.66667 0.75C4.25245 0.75 3.91667 1.08579 3.91667 1.5H5.41667ZM11.9823 9.9L12.7319 9.92616L11.9823 9.9ZM1.01768 6.3L0.268135 6.27384L1.01768 6.3ZM11.9823 6.3L12.7319 6.27384L11.9823 6.3ZM6.5 12.75C5.33784 12.75 4.52538 12.749 3.90099 12.6826C3.28984 12.6176 2.94812 12.497 2.69509 12.3165L1.824 13.5376C2.37417 13.9301 3.00692 14.0959 3.74233 14.1742C4.46449 14.251 5.37066 14.25 6.5 14.25V12.75ZM0.25 8.1C0.25 9.20791 0.248933 10.1002 0.32747 10.8119C0.407648 11.5385 0.578122 12.1655 0.980677 12.7095L2.18644 11.8172C2.00544 11.5726 1.88413 11.2429 1.81842 10.6474C1.75107 10.037 1.75 9.24193 1.75 8.1H0.25ZM2.69509 12.3165C2.49938 12.1769 2.32783 12.0083 2.18644 11.8172L0.980677 12.7095C1.21622 13.0278 1.50091 13.3072 1.824 13.5376L2.69509 12.3165ZM10.8136 11.8172C10.6722 12.0083 10.5006 12.1769 10.3049 12.3165L11.176 13.5376C11.4991 13.3072 11.7838 13.0278 12.0193 12.7095L10.8136 11.8172ZM10.3049 3.88352C10.5006 4.02313 10.6722 4.19171 10.8136 4.38278L12.0193 3.49051C11.7838 3.17221 11.4991 2.89284 11.176 2.66237L10.3049 3.88352ZM1.824 2.66237C1.50091 2.89285 1.21622 3.17221 0.980677 3.49051L2.18644 4.38278C2.32783 4.19171 2.49938 4.02313 2.69509 3.88352L1.824 2.66237ZM10.7957 9.19584C9.17493 9.44787 7.89059 10.6991 7.63052 12.3113L9.11138 12.5501C9.26547 11.5949 10.032 10.8326 11.0261 10.678L10.7957 9.19584ZM4.66667 9.45H8.33333V7.95H4.66667V9.45ZM11.9823 9.15C11.4534 9.15 11.1022 9.14818 10.7957 9.19584L11.0261 10.678C11.1897 10.6526 11.3994 10.65 11.9823 10.65L11.9823 9.15ZM11.25 8.1C11.25 8.80558 11.2499 9.3831 11.2328 9.87384L12.7319 9.92616C12.7501 9.40368 12.75 8.79713 12.75 8.1H11.25ZM11.2328 9.87384C11.1941 10.982 11.067 11.4747 10.8136 11.8172L12.0193 12.7095C12.5691 11.9665 12.6925 11.055 12.7319 9.92616L11.2328 9.87384ZM9.08333 13.4826C9.08334 12.9088 9.0861 12.7069 9.11138 12.5501L7.63052 12.3113C7.58136 12.6161 7.58334 12.9648 7.58333 13.4826L9.08333 13.4826ZM6.5 14.25C7.21027 14.25 7.82726 14.2501 8.35855 14.2322L8.30812 12.7331C7.80743 12.7499 7.21842 12.75 6.5 12.75V14.25ZM8.35855 14.2322C9.50599 14.1936 10.4253 14.0731 11.176 13.5376L10.3049 12.3165C9.94993 12.5697 9.43912 12.695 8.30812 12.7331L8.35855 14.2322ZM1.75 8.1C1.75 7.39442 1.7501 6.8169 1.76722 6.32616L0.268135 6.27384C0.249903 6.79632 0.25 7.40287 0.25 8.1H1.75ZM1.76722 6.32616C1.80589 5.218 1.93296 4.72532 2.18644 4.38278L0.980677 3.49051C0.430874 4.23349 0.307527 5.14498 0.268135 6.27384L1.76722 6.32616ZM1.01768 7.05H11.9823V5.55H1.01768V7.05ZM12.75 8.1C12.75 7.40287 12.7501 6.79632 12.7319 6.27384L11.2328 6.32616C11.2499 6.8169 11.25 7.39442 11.25 8.1H12.75ZM12.7319 6.27384C12.6925 5.14498 12.5691 4.23349 12.0193 3.49051L10.8136 4.38278C11.067 4.72532 11.1941 5.218 11.2328 6.32616L12.7319 6.27384ZM9.08333 3.3V2.71736H7.58333V3.3H9.08333ZM9.08333 2.71736V1.5H7.58333V2.71736H9.08333ZM6.5 3.45C7.21842 3.45 7.80743 3.45009 8.30812 3.46693L8.35855 1.96778C7.82726 1.94991 7.21027 1.95 6.5 1.95V3.45ZM8.30812 3.46693C9.43912 3.50498 9.94993 3.63031 10.3049 3.88352L11.176 2.66237C10.4253 2.12691 9.50599 2.00638 8.35855 1.96778L8.30812 3.46693ZM5.41667 3.3V2.71736H3.91667V3.3H5.41667ZM5.41667 2.71736V1.5H3.91667V2.71736H5.41667ZM6.5 1.95C5.78973 1.95 5.17274 1.94991 4.64145 1.96778L4.69188 3.46693C5.19257 3.45009 5.78158 3.45 6.5 3.45V1.95ZM4.64145 1.96778C3.49401 2.00638 2.57465 2.12691 1.824 2.66237L2.69509 3.88352C3.05007 3.63031 3.56088 3.50498 4.69188 3.46693L4.64145 1.96778Z"
                fill="#2D264B" fill-opacity="0.25" />
            </svg>
            <span class="font-semibold">{{formatDate(event.startTime, event.endTime)}}</span>
          </p>
        </div>

        <div class="flex gap-3 items-start justify-end">
          <!-- RSVP Buttons for all events -->
          <div *ngIf="!hasRSVPResponse()" class="flex gap-2 mt-4 2xl:mt-0">
            <button
              nz-button 
              class="add-post-btn font-medium"
              (click)="addParticipant('WillAttend')"
              [nzLoading]="false">
              I Will Attend
            </button>
            <button
              nz-button 
              class="bg-gray-500 hover:bg-gray-600 text-white font-medium px-4 py-2 rounded"
              (click)="addParticipant('WillNotAttend')"
              [nzLoading]="false">
              I Will Not Attend
            </button>
          </div>
          
          <!-- Show current RSVP status if user has responded -->
          <div *ngIf="hasRSVPResponse()" class="mt-4 2xl:mt-0">
            <nz-alert 
              *ngIf="getRSVPResponse() === 'willAttend'"
              nzType="success" 
              nzMessage="You have responded: I will attend"
              [nzShowIcon]="true">
            </nz-alert>
            <nz-alert 
              *ngIf="getRSVPResponse() === 'willNotAttend'"
              nzType="info" 
              nzMessage="You have responded: I will not attend"
              [nzShowIcon]="true">
            </nz-alert>
          </div>

          <div *ngIf="event.link && showLink() && isExpired(event.endTime)">
            <a [href]="event.link" target="_blank">
              <button nz-button class="add-post-btn font-medium mt-4 2xl:mt-0">
                Join Webinar
              </button>
            </a>
          </div>

        </div>
      </div>

      <div class="common-border ">
        <div class="py-[15px]">
          <h3 class="mb-5">Description</h3>
          <p class="w-full font-[400]" [innerHTML]="serializeToHTML(this.event.description1)"></p>
        </div>
      </div>

      <div class="common-border ">
        <div class="py-[15px]">
          <h3 class="mb-5">Resources</h3>
          <p class="w-full  mb-2 font-[400]" [innerHTML]="serializeToHTML(this.event.resources1)"></p>
        </div>
      </div>


      <div *ngIf="hasAgendaContent()"  class="common-border">
        <div class="py-[15px]">
          <h3 class="mb-5">Agenda</h3>
          <p class="w-full font-[400]" *ngIf="event.agenda1" [innerHTML]="serializeToHTML(event.agenda1)"></p>
          <a *ngIf="event.agendaPDFs?.url" [href]="event.agendaPDFs.url" nz-button class="add-post-btn font-medium"
            target="_blank">
            View
          </a>
        </div>
      </div>

      <!-- Participant List PDF -->
      <div *ngIf="event.participantListPDF?.url" class="common-border">
        <div class="py-[15px]">
          <h3 class="mb-5">Participant List</h3>
          <div class="mb-2 clickable-text bg-[#F0F2F5] max-w-[300px] w-full px-3 py-4 flex justify-start gap-3 items-center rounded-md">
            <img src="assets/img/signle-event/pdf.png" alt="pdf" />
            <a [href]="event.participantListPDF.url" target="_blank">
              <h6>{{ event.participantListPDF.alt || event.participantListPDF.filename || 'Download Participant List' }}</h6>
            </a>
          </div>
        </div>
      </div>


      <div class="common-border ">
        <div class="py-[15px]">
          <h3 class="mb-3">Participants</h3>


          <div class="">
            <nz-tabset [nzCentered]="false">

              <nz-tab nzTitle="Attending">

                <div *ngIf="!event.willAttend  || event.willAttend.length < 1">
                  <p class="font-medium">No Current Participants</p>
                </div>

                <div *ngIf="event.willAttend">
                  <div class="flex justify-start items-center gap-3 mb-5"
                    *ngFor="let member of event.willAttend.slice(0, 4)">
                    <div *ngIf="member.profilePicture">
                      <img class="w-[50px] object-contain rounded-full" (error)="onImageProfile($event)"
                        [src]="member.profilePicture.url" alt="user" />
                    </div>
                    <div *ngIf="!member.profilePicture">
                      <img class="w-[50px] object-contain rounded-full" (error)="onImageProfile($event)"
                        src="assets/img/avatar_image.jpg" alt="user" />
                    </div>
                    <div>
                      <h4 class="!my-0">{{ member.name }}</h4>
                      <p class="text-[#6D6D6D] font-[400] !my-0">{{ member.position }} · {{ member.workplace }}</p>
                    </div>
                  </div>

                  <p *ngIf="event.willAttend.length > 4 && !showMoreAcc" (click)="showMoreAcc = !showMoreAcc"
                    class="clickable-text text-[#441752] mt-10 font-[600] w-full max-w-[550px] text-right"> {{
                    showMoreAcc ? 'Show Less' : '+' + (event.willAttend.length - 4) + 'More - View All Participants' }}
                  </p>


                  <div *ngIf="showMoreAcc">
                    <div class="flex justify-start items-center gap-3 mb-5"
                      *ngFor="let member of event.willAttend.slice(4)">
                      <div *ngIf="member.profilePicture">
                        <img class="w-[50px] object-contain rounded-full" (error)="onImageProfile($event)"
                          [src]="member.profilePicture.url" alt="user" />
                      </div>
                      <div *ngIf="!member.profilePicture">
                        <img class="w-[50px] object-contain rounded-full" (error)="onImageProfile($event)"
                          src="assets/img/avatar_image.jpg" alt="user" />
                      </div>

                      <div>
                        <h4 class="!my-0">{{ member.name }}</h4>
                        <p class="text-[#6D6D6D] font-[400] !my-0">{{ member.position }} · {{ member.workplace }}</p>
                      </div>
                    </div>
                  </div>

                  <p *ngIf="event.willAttend.length > 4 && showMoreAcc" (click)="showMoreAcc = !showMoreAcc"
                    class="clickable-text text-[#441752] mt-10 font-[600] w-full max-w-[550px] text-right"> {{
                    showMoreAcc ? 'Show Less' : '+' + (event.willAttend.length - 4) + 'More - View All Participants' }}
                  </p>
                </div>
              </nz-tab>

              <nz-tab nzTitle="Not Attending">
                <div *ngIf="!event.willNotAttend  || event.willNotAttend.length < 1">
                  <p class="font-medium">No Current Participants</p>
                </div>

                <div *ngIf="event.willNotAttend">
                  <div class="flex justify-start items-center gap-3 mb-5"
                    *ngFor="let member of event.willNotAttend.slice(0, 4)">
                    <div *ngIf="member.profilePicture">
                      <img class="w-[50px] object-contain rounded-full" (error)="onImageProfile($event)"
                        [src]="member.profilePicture.url" alt="user" />
                    </div>
                    <div *ngIf="!member.profilePicture">
                      <img class="w-[50px] object-contain rounded-full" (error)="onImageProfile($event)"
                        src="assets/img/avatar_image.jpg" alt="user" />
                    </div>
                    <div>
                      <h4 class="!my-0">{{ member.name }}</h4>
                      <p class="text-[#6D6D6D] font-[400] !my-0">{{ member.position }} · {{ member.workplace }}</p>
                      <p *ngIf="getReasonForMember(member.id)" class="text-sm text-gray-500 mt-1">
                        Reason: {{ getReasonForMember(member.id) }}
                      </p>
                    </div>
                  </div>

                  <p *ngIf="event.willNotAttend.length > 4 && !showMoreRej" (click)="showMoreRej = !showMoreRej"
                    class="clickable-text text-[#441752] mt-10 font-[600] w-full max-w-[550px] text-right"> {{
                    showMoreRej ? 'Show Less' : '+' + (event.willNotAttend.length - 4) + 'More - View All Participants' }}</p>

                  <div *ngIf="showMoreRej">
                    <div class="flex justify-start items-center gap-3 mb-5"
                      *ngFor="let member of event.willNotAttend.slice(4)">
                      <div *ngIf="member.profilePicture">
                        <img class="w-[50px] object-contain rounded-full" (error)="onImageProfile($event)"
                          [src]="member.profilePicture.url" alt="user" />
                      </div>
                      <div *ngIf="!member.profilePicture">
                        <img class="w-[50px] object-contain rounded-full" (error)="onImageProfile($event)"
                          src="assets/img/avatar_image.jpg" alt="user" />
                      </div>
                      <div>
                        <h4 class="!my-0">{{ member.name }}</h4>
                        <p class="text-[#6D6D6D] font-[400] !my-0">{{ member.position }} · {{ member.workplace }}</p>
                        <p *ngIf="getReasonForMember(member.id)" class="text-sm text-gray-500 mt-1">
                          Reason: {{ getReasonForMember(member.id) }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <p *ngIf="event.willNotAttend.length > 4 && showMoreRej" (click)="showMoreRej = !showMoreRej"
                    class="clickable-text text-[#441752] mt-10 font-[600] w-full max-w-[550px] text-right"> {{
                    showMoreRej ? 'Show Less' : '+' + (event.willNotAttend.length - 4) + 'More - View All Participants' }}</p>
                </div>
              </nz-tab>


            </nz-tabset>
          </div>


        </div>
      </div>

      <!-- Logistics and Reports section -->
<div class="common-border" *ngIf="event.logisticReports && event.logisticReports.length > 0">
  <div class="py-[15px]">
    <h3 class="mb-5">Logistics and Reports</h3>
    <div class="flex gap-3">
      <div *ngFor="let media of event.logisticReports">
        
        <div
          class="mb-2 clickable-text bg-[#F0F2F5] max-w-[300px] w-full px-3 py-4 flex justify-start gap-3 items-center rounded-md"
          *ngIf="media.mimeType === 'application/pdf'">
          <img src="assets/img/signle-event/pdf.png" alt="pdf" />
          <a [href]="media.url" target="_blank">
            <h6>{{ media.alt || media.filename }}</h6>
          </a>
        </div>

        <div
          class="mb-2 clickable-text bg-[#F0F2F5] max-w-[150px] w-full px-1 py-4 flex justify-center gap-3 items-center rounded-md"
          *ngIf="media.mimeType?.startsWith('image/')">
          <a [href]="media.url" target="_blank">
            <img [src]="media.url" alt="{{media.filename}}" style="width: 100%; height: 150px" />
            <h6>{{ media.alt || media.filename }}</h6>
          </a>
        </div>

      </div>
    </div>
  </div>
</div>
    </div>
  </div>
</nz-card>


<!-- Reason Modal -->
<nz-modal 
  [(nzVisible)]="isReasonModalVisible" 
  nzTitle="Reason for Not Attending" 
  [nzFooter]="null"
  [nzWidth]="320"
  (nzOnCancel)="handleCancel()"
  nzClosable="true">
  <div *nzModalContent>
    <div class="mb-4">
      <p class="text-gray-600 mb-4">Please provide a reason for not attending this event. This information will be recorded and visible to event organizers.</p>
    </div>
    <form nz-form [formGroup]="reasonForm">
      
        <nz-form-control nzErrorTip="Reason is required" [nzHasFeedback]="true">
          <textarea 
            nz-input 
            formControlName="reason" 
            rows="6" 
            placeholder="Enter your reason here..."
            class="min-w-[280px]"
            style="min-height: 120px; resize: vertical;">
          </textarea>
        </nz-form-control>
     
      <div class="flex justify-end gap-3 mt-6 pt-4 border-t">
        <button 
          nz-button 
          (click)="handleCancel()"
          class="px-6">
          Cancel
        </button>
        <button 
          nz-button 
          nzType="primary" 
          [disabled]="reasonForm.invalid || reasonForm.get('reason')?.value?.trim() === ''" 
          (click)="handleReasonSubmit()"
          class="px-6">
          Submit
        </button>
      </div>
    </form>
  </div>
</nz-modal>

<nz-modal [(nzVisible)]="isVisibleForm" [nzTitle]="modalTitle" [nzContent]="modalContent" [nzFooter]="null"
  (nzOnCancel)="handleCancel()">
  <ng-template #modalTitle>
    <ng-container>
      Attendance Form
    </ng-container>
  </ng-template>

  <ng-template #modalContent>
    <ng-container>
      <form nz-form [formGroup]="attendanceForm">
        <div class="flex flex-col gap-4">
          <div class="w-full">
            <p class="font-normal mb-0">Name of the Judge (Readonly)</p>
            <nz-form-item>
              <nz-form-control nzErrorTip="Name is required" class="w-full">
                <nz-input-group>
                  <input type="text" nz-input formControlName="name" [placeholder]="this.loggedUser.name"
                    title="Name of the Judge" readonly />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div class="flex lg:flex-row flex-col lg:gap-3">
            <div class="lg:w-1/2 w-full">
              <p class="font-normal mb-0">Designation</p>
              <nz-form-item>
                <nz-form-control nzErrorTip="Enter Designation" class="w-full">
                  <nz-input-group>
                    <input type="text" nz-input formControlName="designation" placeholder="Enter Designation" />
                  </nz-input-group>
                  <div
                    *ngIf="getFormControl('designation')!.invalid && (getFormControl('designation')!.dirty || getFormControl('designation')!.touched)">
                    <small *ngIf="getFormControl('designation')!.errors?.['required']" class="text-red-500">Designation
                      is required</small>
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="lg:w-1/2 w-full">
              <p class="font-normal mb-0">Station</p>
              <nz-form-item>
                <nz-form-control nzErrorTip="Enter Station" class="w-full">
                  <nz-input-group>
                    <input type="text" nz-input formControlName="station" placeholder="Enter Station" />
                  </nz-input-group>
                  <div
                    *ngIf="getFormControl('station')!.invalid && (getFormControl('station')!.dirty || getFormControl('station')!.touched)">
                    <small *ngIf="getFormControl('station')!.errors?.['required']" class="text-red-500">Station is
                      required</small>
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div class="w-full">
            <p class="font-normal mb-0">No of Accompanying Persons (Adults)</p>
            <nz-form-item>
              <nz-form-control nzErrorTip="Count is required" class="w-full">
                <nz-input-group>
                  <input type="text" nz-input formControlName="adultCount" placeholder="Enter Numeric Value" />
                </nz-input-group>
                <div
                  *ngIf="getFormControl('adultCount')!.invalid && (getFormControl('adultCount')!.dirty || getFormControl('adultCount')!.touched)">
                  <small *ngIf="getFormControl('adultCount')!.errors?.['required']" class="text-red-500">Adult count is
                    required</small>
                  <small *ngIf="getFormControl('adultCount')!.errors?.['pattern']" class="text-red-500">Must be a
                    numeric value</small>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div class="w-full">
            <p class="font-normal mb-0">No of Accompanying Children with their Age</p>
            <div class="flex lg:flex-row flex-col lg:gap-3">
              <nz-form-item class="mb-3 lg:w-1/2">
                <nz-form-control nzErrorTip="Children count is required" class="w-full">
                  <nz-input-group>
                    <input type="text" nz-input formControlName="childrenCount"
                      placeholder="Enter 0 if there are no children" />
                  </nz-input-group>
                  <div
                    *ngIf="getFormControl('childrenCount')!.invalid && (getFormControl('childrenCount')!.dirty || getFormControl('childrenCount')!.touched)">
                    <small *ngIf="getFormControl('childrenCount')!.errors?.['required']" class="text-red-500">Children
                      count is required</small>
                    <small *ngIf="getFormControl('childrenCount')!.errors?.['pattern']" class="text-red-500">Must be a
                      numeric value</small>
                  </div>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item class="mb-3 lg:w-1/2">
                <nz-form-control class="w-full">
                  <nz-input-group>
                    <input type="text" nz-input formControlName="childrenAge" placeholder="Eg: 2,5,9" />
                  </nz-input-group>
                  <div
                    *ngIf="getFormControl('childrenAge')!.invalid && (getFormControl('childrenAge')!.dirty || getFormControl('childrenAge')!.touched)">
                    <small *ngIf="getFormControl('childrenAge')!.errors?.['required']" class="text-red-500">Children age
                      is required</small>
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div class="w-full">
            <p class="font-normal mb-0">Room Type</p>
            <nz-form-item class="mb-3">
              <nz-form-control nzErrorTip="Room Type required" class="w-full">
                <nz-input-group>
                  <input type="text" nz-input formControlName="roomType"
                    placeholder="Double/Triple or other - specify" />
                </nz-input-group>
                <div
                  *ngIf="getFormControl('roomType')!.invalid && (getFormControl('roomType')!.dirty || getFormControl('roomType')!.touched)">
                  <small *ngIf="getFormControl('roomType')!.errors?.['required']" class="text-red-500">Room type is
                    required</small>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div class="w-full">
            <p class="font-normal mb-0">Expected Dates of Stay</p>
            <nz-form-item class="mb-3">
              <nz-form-control nzErrorTip="Dates are required" class="w-full">
                <nz-input-group>
                  <input type="text" nz-input formControlName="datesOfStay" placeholder="Enter Dates" />
                </nz-input-group>
                <div
                  *ngIf="getFormControl('datesOfStay')!.invalid && (getFormControl('datesOfStay')!.dirty || getFormControl('datesOfStay')!.touched)">
                  <small *ngIf="getFormControl('datesOfStay')!.errors?.['required']" class="text-red-500">Dates of stay
                    are required</small>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div class="flex justify-end">
            <button nz-button nzType="primary" [disabled]="attendanceForm.invalid"
              (click)="handleAttendanceFormSubmit()">
              Confirm Attendance
            </button>
          </div>
        </div>
      </form>

    </ng-container>
  </ng-template>
</nz-modal>